import React from 'react';

import PropTypes from 'prop-types';
import { Typography } from '@telus-uds/components-web';

import StatusError from '@telus-uds/palette-allium/build/web/icons/StatusError';
import { Title } from './css';
import { useLocalizedStringsContext } from '../context/LocalizedStringsContext';

const ProfileInfo = ({ error }) => {
  const localizedStrings = useLocalizedStringsContext();
  const {
    USERS: {
      USER_AUTHENTICATION: {
        labels: { REGISTRATION_INFO_HEADING, REGISTRATION_INFO_FILL_DETAIL },
        ERRORS_MESSAGES: { GENERIC_ERROR_HEADING }
      }
    }
  } = localizedStrings;

  return (
    <>
      <Typography heading="h2" variant={{ size: 'h2' }}>
        <div id="main-content-title">
          <Title>{REGISTRATION_INFO_HEADING}</Title>
        </div>
      </Typography>
      <div id="main-content-steps">
        <Typography variant={{ bold: true }}>{REGISTRATION_INFO_FILL_DETAIL}</Typography>
      </div>

      {error ? (
        <div id="error-message-content" style={{ display: 'block' }}>
          <div id="error-message-icon">
            <StatusError size={16} color="#C12335" aria-hidden="true" />
          </div>
          <div id="error-message-title">
            <span className="frg-body-font-23px">{GENERIC_ERROR_HEADING}</span>
          </div>
          <div className="clear" />
          <div id="error-message-message">
            <span className="frg-body-font-14px">
              {error}
              <br />
            </span>
          </div>
        </div>
      ) : null}
    </>
  );
};

ProfileInfo.propTypes = {
  error: PropTypes.bool.isRequired
};

export default ProfileInfo;
